<template>
	<div>
		<p class="sr-only">En cours de chargement.</p>
		<font-awesome-icon :icon="['fas', 'spinner']" size="3x" pulse />
	</div>
</template>
<script>
export default {
	name: "EbLoader",
}
</script>

